import React from 'react';
import UserProfile from '../../components/UserProfile';

const UserProfilePage = () => (
	<UserProfile />
);

export default UserProfilePage;
